import image1 from './assets/card-1.webp';
import image2 from './assets/card-2.webp';
import image3 from './assets/card-3.webp';
import image4 from './assets/card-4.webp';
import image5 from './assets/card-5.webp';

export const infrastructureContent = {
  title: [
    { text: 'всё, что важно — под рукой: ', accent: true },
    { text: 'от медицины до личного пляжа', accent: false },
  ],
  subtitle: [
    { text: 'район полностью интегрирован \n', accent: true, break: true },
    { text: 'в городскую среду: ', accent: true },
    { text: 'все сервисы — от продуктов', accent: true },
    { text: 'до университета — доступны за 5-10 минут', accent: false },
  ],
  cards: [
    {
      title: [
        [{ text: 'муниципальный', accent: true }],
        [
          { text: 'детский сад ', accent: true },
          { text: 'на 200 мест', accent: false },
        ],
        [{ text: 'на территории ЖК', accent: false }],
      ],
      text: [
        { text: 'находится на территории комплекса,', accent: true },
        { text: 'что исключает утренние поездки по пробкам', accent: false },
      ],
      image: image1,
    },
    {
      title: [[{ text: 'кампус', accent: true }], [{ text: '«Будущее Пармы»', accent: true }]],
      text: [
        { text: 'по соседству возводится межвузовский кампус', accent: true },
        { text: 'мирового уровня на 5000 мест', accent: false },
      ],
      image: image2,
    },
    {
      title: [[{ text: 'ТРК «СпешиLove»', accent: true }], [{ text: 'и «Ашан»', accent: true }]],
      text: [
        { text: 'центр семейного досуга с мягким кинотеатром', accent: true },
        { text: 'и детскими игровыми зонами в 10-15 минутах на авто', accent: false },
      ],
      image: image3,
    },
    {
      title: [[{ text: 'медицинский', accent: true }], [{ text: 'кластер', accent: true }]],
      text: [
        {
          text: 'Федеральный центр сердечно-сосудистой хирургии им. С.Г. Суханова',
          accent: true,
        },
        {
          text: 'и краевой перинатальный центр в непосредственной близости',
          accent: false,
        },
      ],
      image: image4,
    },
    {
      title: [
        [{ text: 'строится детский центр', accent: true }],
        [{ text: 'реабилитации ЦКРИ', accent: true }],
      ],
      text: [
        {
          text: 'профильное медицинское учреждение будет находиться вблизи ЖК.',
          accent: true,
        },
        {
          text: 'Это экономит время на поездки и делает заботу о здоровье ребенка комфортнее',
          accent: false,
        },
      ],
      image: image5,
    },
  ],
  area: {
    kicker: 'генплан',
    title: [
      [{ text: 'продуманное', accent: true }],
      [
        { text: 'пространство: ', accent: true },
        { text: 'от вашего', accent: false },
      ],
      [{ text: 'порога до берега Камы', accent: false }],
    ],
    stats: [
      {
        value: '12,69 га',
        label: [
          { text: 'общая площадь ', accent: true },
          { text: 'благоустроенной территории проекта', accent: false },
        ],
      },
    ],
  },
};
